import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconArrowUp: React.FC<IconProps> = ({ width = 12, height = 8, color = '#303030' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 8"
            fill="none"
        >
            <path
                d="M6 0.300781L0 6.30078L1.4 7.70078L6 3.10078L10.6 7.70078L12 6.30078L6 0.300781Z"
                fill={color}
            />
        </svg>
    );
};

export default IconArrowUp;
